const ResetPreferences = ({ onConfirm, restoreLoading }) => {
  return <div className="card">
    <div className="card-header" id="reset_preferences">
      <h3 className="card-title">Reset Preferences</h3>
    </div>
    <div className="card-body flex flex-col lg:py-7.5 lg:gap-7.5 gap-3">
      <div className="flex flex-col gap-5">
        <div className="text-2sm text-gray-800">
          This puts your preferences back to their default settings, including your date and time
          format. Any changes you have made to them will be lost, and this cannot be undone.
        </div>
      </div>

      <div className="flex justify-end gap-2.5">
        <button className="btn btn-danger btn-outline"
          onClick={onConfirm}
          disabled={restoreLoading}
        >
          {restoreLoading ? 'Please Wait...' : 'Reset to Defaults'}
        </button>
      </div>
    </div>
  </div>;
};
export { ResetPreferences };
